import { Certificate } from '@types';
import { PublicSharedApiService } from './public-shared-api.service';
import { endpoint } from './shared-api.service';

const publicSharedApi = new PublicSharedApiService(endpoint);

export const getAvailableCertificates = async (): Promise<Certificate[]> => {
  return publicSharedApi.get<Certificate[]>({ path: 'public/accreditations/certificates' });
};
